import { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import { InputPassword } from '../../../utils/InputField';
import { handleChangePasswordOpe } from '../SecurityOperation';

function ChangePasswordModal({ closeModal }) {
    const [formData, setFormData] = useState({
        OldPassword: '',
        NewPassword1: '',
        NewPassword2: ''
    });
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const { setMessage } = useTemplate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        setLoading(true);
        handleChangePasswordOpe(formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                setFormData({});
                closeModal();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="mb-4">
                <div className="flex flex-col gap-y-4">
                    <InputPassword
                        label="Old Password"
                        placeholder="Type Old Password"
                        name="OldPassword"
                        formData={formData}
                        onChange={handleChange}
                    />
                    <InputPassword
                        label="New Password"
                        placeholder="Type New Password"
                        name="NewPassword1"
                        formData={formData}
                        onChange={handleChange}
                    />
                    <InputPassword
                        label="Confirm New Password"
                        placeholder="Re-Type New Password"
                        name="NewPassword2"
                        className="placeholder:text-red-100"
                        formData={formData}
                        onChange={handleChange}
                    />

                    <p className="text-sm text-error/90 font-normal leading-6 mb-3">
                        Password must contain at least 1 Letter, 1 Number & 1 Symbol. Minimum length
                        is 8 characters.
                    </p>
                </div>
            </div>
            <div className="flex justify-end">
                <div className="flex items-center gap-x-2">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save Change" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ChangePasswordModal;
